// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill";
import Vue from "vue";
import VueMeta from "vue-meta";
import App from "./App";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import store from "@/store/index";
import Slick from "vue-slick";
import Meta from "vue-meta";
import VueHead from "vue-head";
import VueLocalStorage from "vue-localstorage";
import GSignInButton from "vue-google-signin-button";
import FBSignInButton from "vue-facebook-signin-button";
import Carousel3d from "vue-carousel-3d";
import VueFriendlyIframe from "vue-friendly-iframe";
import VueScrollTo from "vue-scrollto";
import VeeValidate from "vee-validate";
import * as VueGoogleMaps from "vue2-google-maps";
import VCalendar from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";
import VueQrcodeReader from "vue-qrcode-reader";
import Multiselect from "vue-multiselect";
import VueLazyload from "vue-lazyload";
import ReadMore from "vue-read-more";
import OTPInput from "vue-otp-input";
import vSelect from 'vue-select'

//LOADER COMPONENT
// Import component
import Loading from "vue-loading-overlay";
import LightBox from "lightbox2";
import CoolLightBox from "vue-cool-lightbox";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "slick-carousel/slick/slick.css";
import "./assets/css/style.css";
import "./assets/css/common.css";
// import "./assets/css/old-style.css";
import "./assets/css/slick-slide.css";
import "./assets/css/fancybox.css";
import "animate.css";
import "./assets/css/responsive.css";
import TestimonialData from "@/data/json/testimonial-data.json";
import RecentPostData from "@/data/json/recent-post-data.json";
import PricingPlanData from "@/data/json/pricing-plan.json";
import 'vue-select/dist/vue-select.css';

Vue.component('v-select', vSelect)
Vue.use(BootstrapVue);
Vue.use(LightBox);
Vue.use(CoolLightBox);
Vue.use(VueMeta);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/static/imgs/logo_p_ver.png",
  loading: "/static/imgs/logo_p_ver.png",
  attempt: 1,
});
Vue.use(VueScrollTo);
Vue.use(VCalendar);
Vue.use(VeeValidate);
Vue.component("slick", Slick);
Vue.use(Carousel3d);
Vue.use(GSignInButton);
Vue.use(FBSignInButton);
Vue.use(VueHead);
Vue.use(Meta);
Vue.use(Loading);
Vue.use(VueQrcodeReader);
Vue.component("multiselect", Multiselect);
Vue.use(ReadMore);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDTN4bmtcbXEqjsv8B0cx2zG15TIz6-03w", //"AIzaSyDpx-CIzu0s5C-gd8Ntp1t3fCldYbo7ccw"//"AIzaSyACDkTbwhQBjD6Ml9fJYEx35ZunrKh8KHQ"
  },
});
Vue.use(VueLocalStorage, {
  name: "persistStore",
});
Vue.config.productionTip = false;
Vue.component("vue-friendly-iframe", VueFriendlyIframe);
Vue.component("v-otp-input", OTPInput);

// Created the Event Bus for the call parent function
export const EventBus = new Vue();

import _ from "lodash";

Vue.mixin({
  data: function() {
    return {
      testimonialData: TestimonialData,
      recentPostData: RecentPostData,
      pricingPlanData: PricingPlanData,
    };
  },
  mounted() {},
  computed: {},
  methods: {},
});

/* eslint-disable no-new */
let app = new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./src/main.js